import React from 'react';

import {
  BooleanInput,
  NumberInput,
  TextInput,
} from './components';
import {INPUT_TYPE} from './constants';

type Callback = (value?: any) => void;

interface InputFactoryProps {
  type: string;
  value: string;
  disabled?: boolean;
  onChange: Callback;
}

export const InputFactory = ({
  type,
  value,
  disabled = false,
  onChange,
}: InputFactoryProps) => {
  switch (type) {
    case INPUT_TYPE.BOOLEAN:
      return <BooleanInput value={value} disabled={disabled} onChange={onChange}/>;
    /*case INPUT_TYPE.DATE:
      return <DateInput value={value} disabled={disabled} onChange={onChange}/>;*/
    case INPUT_TYPE.NUMBER:
      return <NumberInput value={value} disabled={disabled} onChange={onChange}/>;
    case INPUT_TYPE.TEXT:
      return <TextInput value={value} disabled={disabled} onChange={onChange}/>;
    default:
      return null;
  }
};

export default InputFactory;
